import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { StateToObj } from "./reduxHelper";

const initialState = {
    "id" : uuidv4(),
    "data": []
}

const updateMuteStatues = (data,state) => {
        return [{...state[0],
            recent:{
                ...state[0].recent,
                muteStatus: data?.isMuted ? 1 : 0
            }}
        ]
}

const activeChatData = createSlice({
    name:'activeChatData',
    initialState,
    reducers:{
        addActiveChatData: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data":payload.payload ? [payload.payload] : []
               }
        },
        logOutActiveChatData: (_state,payload)=>{
            return initialState;
        },
        resetActiveChatData:(_state,payload)=>{
                return initialState;
        },
        updateMuteStatusActiveChat:(_state,payload)=>{
            return {
            "id" : uuidv4(),
            "data": updateMuteStatues(payload.payload,StateToObj(_state).data)
            };
        }
    }
});

export default activeChatData.reducer
export const addActiveChatData = activeChatData.actions.addActiveChatData
export const logOutActiveChatData = activeChatData.actions.logOutActiveChatData
export const resetActiveChatData = activeChatData.actions.resetActiveChatData
export const updateMuteStatusActiveChat = activeChatData.actions.updateMuteStatusActiveChat